/**
 * A tick-label character's width as a share of the font size. Tick labels are
 * short numbers ('12', '.900', '1.50'); a digit in the tenant fonts runs a
 * little under 0.6em, so this errs wide rather than clip.
 */
export const Y_LABEL_CHAR_EM = 0.625

/** Bold capitals (mobile's 'GP' bar label) run wider than digits. */
export const Y_LABEL_CAPS_CHAR_EM = 0.85

/** Web's chart label size, the default. */
const DEFAULT_LABEL_FONT_SIZE = 12

/**
 * Width of the y-axis labels' column: just enough for the longest label plus
 * its gap to the gridlines, never less than `minInset` (the right inset), so
 * the plot sits as wide as the card allows. No labels → `minInset`.
 */
export const getYAxisInset = (
  labels: string[],
  labelGap: number,
  minInset: number,
  fontSize: number = DEFAULT_LABEL_FONT_SIZE,
  charEm: number = Y_LABEL_CHAR_EM
): number => {
  const longest = Math.max(0, ...labels.map((label) => label.length))
  if (longest === 0) {
    return minInset
  }
  return Math.max(minInset, Math.ceil(longest * charEm * fontSize) + labelGap)
}
